<div class="img-grid-block">
  <div
    class="layout-wrap {{blockElement.isActiveForEdit?'':'grid-img-'+blockElement.imageCount}} type-{{blockElement.layout ?? 1}} {{blockElement.isActiveForEdit || stopAnimation?'':'animation-on'}}">
    <div class="layer-div" [ngClass]="{'d-none':!imageUrl && !blockElement.isActiveForEdit}"
      *ngFor="let imageUrl of imageUrlList;let i=index">
      <div class="upload-outer" [ngStyle]="{'display':!imageUrl && blockElement.isActiveForEdit?'flex':'none'}">
        <app-input #fileInput [inputType]="'file'" [acceptFormat]="'image/*'"
          [fControl]="formGroup.controls['Image'+(i+1)]" [isRequired]="false"
          (change)="onFileSelected($event,i)"></app-input>
        <div class="upload-inner">
          <img src="./assets/images/ic-upload.svg" alt="Icon">
          <span>Upload Your Image</span>
        </div>
      </div>
      <img *ngIf="imageUrl" [src]="imageUrl" class="{{i===0?'big-img':''}}"
        (click)="blockElement.isActiveForEdit? onClick(fileInput) : swapImages($event)" alt="Image">
    </div>
  </div>
</div>